import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

// Per-part zoom overrides for visualizerType "kvScene" — see the shape/unit docs in
// ../featureGroupZoomDefaults.ts (getFeatureZoomOverride). Bulk-ported (2026-08-15) from
// scss/bv/responsive-canvas-kvScene.scss's per-part `scale(X)` values.
export function getKvSceneFeatureZoomOverride(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    case "backsplash":
      return {
        scale: 1,
        byLayoutType: {
          1: { offsetX: 0, offsetY: 30, scale: 1 },
        },
      };
    case "top_cabinet":
      return {
        scale: 1,
        byLayoutType: {
          1: { offsetX: 0, offsetY: 0, scale: 1 },
          2: { offsetX: 40, offsetY: 30, scale: 1 },
          4: { offsetX: 90, offsetY: 0, scale: 1 },
        },
      };
    case "top_handle":
      return {
        scale: 1.3,
        byLayoutType: {
          1: { offsetX: 0, offsetY: 0, scale: 1.3 },
          2: { offsetX: 40, offsetY: 30, scale: 1.3 },
          4: { offsetX: 90, offsetY: 10, scale: 1.3 },
        },
      };
    case "bottom_cabinet":
      return {
        scale: 1,
        byLayoutType: {
          1: { offsetX: 15, offsetY: 80, scale: 1 },
          4: { offsetX: 50, offsetY: 80, scale: 1 },
        },
      };
    case "bottom_handle":
      return {
        scale: 1.3,
        byLayoutType: {
          1: { offsetX: 15, offsetY: 80, scale: 1.3 },
          2: { offsetX: 40, offsetY: 60, scale: 1.3 },
        },
      };
    case "center_island_cabinet":
      return {
        scale: 1,
        byLayoutType: {
          1: { offsetX: 50, offsetY: 90, scale: 0.9 },
        },
      };
    case "fridge_enclosure":
    case "tall_cabinet":
    case "countertop":
    case "center_island_countertop":
    case "edge":
    case "edge_profile":
    case "center_island_edge":
    case "kitchen_floor":
    case "left_wall":
    case "right_wall":
    case "front_wall":
    case "back_wall":
      return { scale: 1 };
    case "dishwasher":
    case "faucet":
    case "faucets":
    case "hood":
    case "oven":
    case "stove":
      return { scale: 1.3 };
    case "center_island_hood":
    case "center_island_pendants":
    case "center_island_stovetop":
    case "fridge":
    case "handle":
      return { scale: 1.1 };
    case "crown_molding":
      return {
        scale: 1.4,
        byLayoutType: {
          1: { offsetX: 50, offsetY: 0, scale: 1.4 },
          4: { offsetX: 85, offsetY: 0, scale: 1.4 },
        },
      };
    case "sink":
      return {
        scale: 1.3,
        byLayoutType: {
          1: { offsetX: 30, offsetY: 50, scale: 1.3 },
        },
      };
    default:
      return undefined;
  }
}
